import { render } from "./CompsView.vue?vue&type=template&id=c9d28714&scoped=true"
import script from "./CompsView.vue?vue&type=script&lang=js"
export * from "./CompsView.vue?vue&type=script&lang=js"

import "./CompsView.vue?vue&type=style&index=0&id=c9d28714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d28714"]])

export default __exports__